import { createAsyncThunk } from "@reduxjs/toolkit";
import AuthServices from "../../Services/AuthServices";
import services from "../../Services/Services";
import {chatLogout, clearMessages} from "../Slices/ChatSocketSlice";
import { debugLog } from "../../Utils/utils";

export const login = createAsyncThunk(
  "auth/login",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await AuthServices.login(userData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || { message: err.message });
    }
  }
);

export const register = createAsyncThunk(
  "auth/register",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await AuthServices.register(userData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || { message: err.message });
    }
  }
);


export const otpActivate = createAsyncThunk(
  "auth/otpActivate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthServices.otpActivate(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || { message: err.message });
    }
  }
);

export const resendOtp = createAsyncThunk(
  "auth/resendOtp",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthServices.resendOtp(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || { message: err.message });
    }
  }
);

export const logout = createAsyncThunk(
  "auth/logout",
  async (_, thunkAPI) => {
    try {
      const response = await AuthServices.logout();
      thunkAPI.dispatch(chatLogout());
      thunkAPI.dispatch(clearMessages());
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || { message: err.message });
    }
  }
);

export const getUserInfo = createAsyncThunk(
  "auth/info",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthServices.getUserInfo();
      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || { message: err.message });
    }
  }
);

export const getChatByUserId = createAsyncThunk(
  "auth/getChatByUserId",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await AuthServices.getChatByUserId(userId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || { message: err.message });
    }
  }
);

export const getUserChatData = createAsyncThunk(
  "auth/getUserChatData",
  async ({ userId, token }, { rejectWithValue }) => {
    try {
      const response = await services.getUserChatData(userId, token);
      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data || { message: err.message });
    }
  }
);

export const updateUser = createAsyncThunk(
  "auth/updateUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthServices.updateUser(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);